export default "__VITE_ASSET__BTPbWAJk__"